import React from 'react';
import TrackingScreen from '@/pages/Tooling/TrackingScreen';
import { PLATE } from '@/pages/Tooling/toolings';

export default function PlateTrackingPage() {
  return <TrackingScreen tooling={PLATE} />;
}
